// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Internal Dependencies:
import Editable from 'components/Editable/Editable'

// Redux:
import { getPageData } from 'actions/page'

class PageHeader extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			prevImage: false,
			imageVersion: true
		}
	}

	componentWillReceiveProps( nextProps ) {
		if ( ! this.props.page || this.props.page == nextProps.page ) {
			return
		}

		const { page } = this.props
		let prevImage

		if ( page.featured_image.url ) {
			prevImage = page.featured_image
		} else {
			prevImage = {
				url: siteData.site_featured_image_url,
				alt: ''
			}
		}

		this.setState({
			prevImage: prevImage,
			imageVersion: ! this.state.imageVersion
		})
	}

	renderLoading() {
		return (
			<div className="page-header page-header-is-loading">
				<div className="-inner">
					<div className="-image"></div>
				</div>
			</div>
		)
	}

	renderContent() {
		const { page } = this.props
		const { prevImage, imageVersion } = this.state
		const imageClassName = imageVersion ? '-img -img-fade-a' : '-img -img-fade-b'

		if ( ! page ) {
			return (
				<div className="page-header">
					<div className="-inner">

					</div>
				</div>
			)
		}

		var subTitle,
			image

		const title = (
			<Editable
				id="page_title"
				element="h1"
				className=""
				content={ page.title.raw }
			/>
		)

		if ( page.subtitle && page.subtitle.rendered ) {
			subTitle = (
				<Editable
					id="page_subtitle"
					element="h2"
					className=""
					content={ page.subtitle.rendered }
				/>
			)
		}

		const srcset = page.featured_image.srcset ? page.featured_image.srcset : undefined

		if ( page.featured_image.url ) {
			image = (
				<div className="-image">
					{ prevImage &&
						<img className="-img-prev" src={ prevImage.url } alt={ prevImage.alt } />
					}

					<img className={ imageClassName } src={ page.featured_image.url } srcSet={ srcset } sizes="100vw" alt={ page.featured_image.alt } />
				</div>
			)
		} else {
			image = (
				<div className="-image">
					{ prevImage &&
						<img className="-img-prev" src={ prevImage.url } alt={ prevImage.alt } />
					}

					<img className={ imageClassName } src={ siteData.site_featured_image_url } alt="" />
				</div>
			)
		}

		return (
			<div className="page-header">
				<div className="-inner">
					{ image }

					{/*<div className="-text">
						<div className="-title">
							{ title }
							{ subTitle }
						</div>
					</div>*/}
				</div>
			</div>
		)
	}

	render() {
		// return (
		// 	<div>
		// 		{ this.props.page.isLoading ? this.renderLoading() : this.renderContent() }
		// 	</div>
		// )

		return this.renderContent()
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( PageHeader )



// WEBPACK FOOTER //
// ./components/PageHeader/PageHeader.jsx